<template>
    <!-- <div class="content"> -->

    <div class="foot-body">
        <div class="body-top">
            <div>
                <p>{{ $t('message.language_1') }}</p>
                <a :href="goDetails(item)" v-for="item in list" :key="item.id" @click.prevent="goDetail(item)">{{
                    item.categoryName }} </a>
            </div>
            <div>
                <p>{{ $t('message.language_2') }}</p>
                <a :href="goProject()" v-for="item in projectList" :key="item.value"
                    @click.prevent="goProjects">{{ item.label }}</a>
            </div>
            <div>
                <div>
                    <p>{{ $t('message.language_34') }}</p>
                    <a href="tel:+86-755-21635132">{{ $t('foot.language_1') }}: +86-755-2163 5132</a>
                    <!-- <a href="tel:+00852-26681868">Hong Kong Tel: 00852-2668 1868</a> -->
                    <a href="tel:+86-755-26612120">{{ $t('foot.language_2') }}: +86-755-2661 2120</a>
                    <a @click="toHref('mailto:sales@kamsled.com')">{{ $t('message.language_98') }}: sales@kamsled.com</a>
                </div>
                <div>
                    <p>{{ $t('message.language_35') }}</p>
                    <span style="display: flex;grid-gap: 50px;">
                        <a href="/downloads">{{ $t('foot.language_3') }}</a>
                        <a @click="goPDF('/createPDF?key=cc3f70328445aa5a4be7a59b7e969347')">{{ $t('foot.language_4')
                            }}</a>
                    </span>
                    <a href="/downloads">{{ $t('foot.language_5') }}</a>
                    <a href="/downloads">{{ $t('foot.language_6') }}</a>
                    <a href="/downloads">{{ $t('foot.language_7') }}</a>
                </div>
            </div>
            <div>
                <div>
                    <p>{{ $t('message.language_36') }}</p>
                    <a href="/company">{{ $t('foot.language_8') }}</a>
                    <a href="/company">{{ $t('foot.language_9') }}</a>
                    <a href="/company">{{ $t('foot.language_10') }}</a>
                    <a href="/company">{{ $t('foot.language_11') }}</a>
                    <a href="/company">{{ $t('foot.language_12') }}</a>
                </div>
                <div>
                    <p>{{ $t('message.language_37') }}</p>
                    <div class="icons">
                        <img class="icon" src="@/assets/image/youtube.png" alt="" srcset=""
                            @click="toHref('https://www.youtube.com/@KAMSLIGHTING')">
                        <img class="icon" src="@/assets/image/tiktok.png" alt="" srcset=""
                            @click="toHref('https://www.tiktok.com/@kamsled.com')">
                        <img class="icon" src="@/assets/image/facebook.png" alt="" srcset=""
                            @click="toHref('https://www.facebook.com/profile.php?id=61575032741391')">
                        <img class="icon" src="@/assets/image/ins.png" alt="" srcset="">
                        <!-- <img class="icon" src="@/assets/image/in.png" alt="" srcset="" > -->
                        <img class="icon" src="@/assets/image/email.png" alt="" srcset=""
                            @click="toHref('mailto:sales@kamsled.com')">
                        <img class="icon" src="@/assets/image/wechart.png" alt="" srcset=""
                            @click="toHref('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIwMzE5NTQzOQ==&scene=124#wechat_redirect')">

                    </div>
                </div>
            </div>
            <div><img class="logo" src="../../assets/image/logo-grey.png" alt=""></div>
        </div>

        <div class="body-bottom ">
            <div class="right">
                <div @click="goPolicy">{{ $t('foot.language_13') }}</div>
                <div @click="goTerms">{{ $t('foot.language_14') }}</div>
                <div>
                    <a href="https://web.whatsapp.com/send?phone=8618126135449&text=Hi%2C%20could%20you%20please%20send%20me%20the%20PDF%20catalog%3F"
                        target="_blank" rel="noopener noreferrer">
                        {{ $t('foot.language_15') }}
                    </a>
                </div>
                <!-- <div>Sitemap</div> -->
            </div>
            <div class="copy">
                {{ $t('foot.language_0') }}
            </div>
            <Login v-show="isShow" @close="closeLogin"></Login>
        </div>

        <!-- </div> -->
    </div>
</template>
<script>
import { getProductType } from '@/api/home';
import { buildTree } from '@/utils/index';
import { listCategories } from '@/api/case_categories';
import Login from '@/components/login';
import i18nMonitorMixin from '@/mixins/i18n-monitor-mixin';
import { encodeParam } from '@/utils/urlCrypto'

export default {
    mixins: [i18nMonitorMixin], // 使用混入获得统一的路由和语言功能
    components: {
        Login
    },
    data() {
        return {
            isShow: false,
            list: [],
            projectList: [],
            id: '',
            title: '',
            type: '',
            pageNum: 1,
            pageSize: 20,
            total: 10,
            baseUrl: process.env.VUE_APP_BASE_API,
        }
    },
    mounted() {
        this.getType();
        this.getProjectTypeList();

        // 监听语言切换，重新请求数据
        this.$store.watch(
            state => state.user.language,
            (newLang, oldLang) => {
                if (newLang && oldLang && newLang.country !== oldLang.country) {
                    this.refreshData();
                }
            },
            { deep: true }
        );
    },
    methods: {
        // 统一的数据刷新方法
        refreshData() {
            this.getType();
            this.getProjectTypeList();
        },

        // 优化后的路由跳转方法（使用新的统一API）
        async goPolicy() {
            if (this.$route.path !== "/privacy-policy") {
                try {
                    await this.$navigateTo('/privacy-policy');
                } catch (error) {
                    console.error('Navigation failed:', error);
                }
            }
        },
        async goTerms() {
            if (this.$route.path !== "/terms-of-service") {
                try {
                    await this.$navigateTo('/terms-of-service');
                } catch (error) {
                    console.error('Navigation failed:', error);
                }
            }
        },
        closeLogin() {
            this.isShow = false;
        },
        // 处理PDF点击，在新标签页打开并进行token校验
        async goPDF(url) {
            if(!this.$store.state.user.token){
               this.$login.show();
                return ;
            }else{

                try {
                    await this.$navigateTo(url);
                } catch (error) {
                    console.error('Navigation failed:', error);
                }
            }
            // if (!this.$store.state.user.token) {
            //     this.$login.show();
            //     // this.$navigateTo('/createPDF')
            //     return;
            // } else {
            //     try {
            //         await this.$navigateTo(url);
            //     } catch (error) {
            //         console.error('Navigation failed:', error);
            //     }

            //     // window.open('/createPDF?key=cc3f70328445aa5a4be7a59b7e969347', '_blank', 'noopener,noreferrer');
            // }
        },

        goDetails(item) {
            return this.$buildHref('/products', {
                id: encodeParam(item.id),
                title: item.categoryName,
                type: this.type
            });
        },
        async goDetail(item) {
            this.typeList.forEach(t => { if (t.id == item.parentId) this.type = t.categoryName; });
            try {
                await this.$navigateTo('/products', {
                    query: {
                        id: item.id,
                        title: item.categoryName,
                        type: this.type
                    }
                });
            } catch (error) {
                console.error('Navigation failed:', error);
            }
        },
        async getType(id) {
            await getProductType({ parentId: id, pageNum: this.pageNum, pageSize: this.pageSize }).then((res) => {
                if (res.code == 200 && id) {
                    this.list = res.rows;
                    this.total = res.total;
                } else {
                    this.typeList = res.rows;
                    this.list = [].concat(...buildTree(res.rows).map((m) => { return m.children }));
                    this.total = this.list.length;
                }
            })
        },
        async getProjectTypeList() {
            await listCategories().then((res) => {
                if (res.code == 200) {
                    this.projectList = res.rows.sort((a, b) => a.categoryOrder - b.categoryOrder);
                    this.projectList = this.projectList.map((m) => { return { label: m.categoryName, value: m.id } })
                }
            })
        },
        async goProjects() {
            try {
                await this.$navigateTo('/project');
            } catch (error) {
                console.error('Navigation failed:', error);
            }
        },
        goProject() {
            return this.$buildHref('/project');
        },

        // 处理外部链接跳转
        toHref(url) {
            if (url.startsWith('mailto:') || url.startsWith('http')) {
                window.open(url, '_blank', 'noopener,noreferrer');
            } else {
                console.warn('Invalid URL:', url);
            }
        }
    }

}
</script>
<style lang="less" scoped>
a {
    color: #999;
    text-decoration: none;

    &:hover {
        color: white;
    }
}

p {
    font-size: 1.125rem;
    font-weight: 400;
    color: white;
    text-align: left;
    cursor: pointer;
}

.content {}

.foot-body {
    padding-top: 2.125rem;
    width: 100%;
    background-color: black;
    color: #999;

    .body-top {
        width: 107.5rem;
        margin: 0 auto;
        display: flex;
        position: relative;
        margin-bottom: .9375rem;

        div {
            flex: 1;
            display: flex;
            flex-direction: column;

            a {
                text-align: left;
                margin-bottom: .75rem;
                font-size: .875rem;
                cursor: pointer;
            }

            .icons {
                display: flex;
                flex-direction: row;
                grid-gap: .5rem;

                .icon {
                    width: 1.5rem;
                    height: 1.5rem;
                    cursor: pointer;
                }

                .icon:hover {
                    transform: scale(1.1);
                }
            }

        }

        .logo {
            width: 8.25rem;
            height: 2.1875rem;
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }

    .body-bottom {
        width: 107.5rem;
        margin: 0 auto;
        display: flex;
        padding: 1.25rem 0 2.5rem 0;
        border-top: solid .0625rem #999;
        justify-content: space-between;

        .right {
            display: flex;

            div {
                margin-right: 1.375rem;
                cursor: pointer;
            }
        }

        .copy {
            cursor: default;
        }
    }
}
</style>